/**
 * @description 全局Model articleInfoModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import {
  APIS,
  CommonResult,
  ArticleTotalVO,
  ParamsBodyvotePublishUsingPost,
  CommonResultVoteQuestionPO,
  ParamsvoteGetUsingGet,
  VoteQuestionPO,
  ParamsvoteFollowVoteQuestionIdUsingPost,
  ParamsvoteVoteQuestionIdUsingPost,
  ParamsBodyvoteCommentUsingPost,
  ParamsvoteCommentVoteQuestionIdHotUsingGet,
  CommentInfo,
  ParamscommentsThumbUpIdUsingPost,
  ParamscommentsThumbUpIdUsingDelete
} from '@src/services';
import { TkitUtils as Utils } from '@tkit/types';
import { IRootState } from '@src/types';
import history from '@src/common/history';

export interface State {
  articleInfoModel: {
    articleInfo: ArticleTotalVO;
  };
  voteInfoModel: {
    voteInfo: VoteQuestionPO;
    hotComment: CommentInfo[];
  };
}

export const voteInfoModelState: State = {
  articleInfoModel: {
    articleInfo: {}
  },
  voteInfoModel: {
    voteInfo: {},
    hotComment: []
  }
};

const model = createModel({
  state: voteInfoModelState,
  namespace: 'voteInfoModel',
  reducers: {
    // 设置关注状态
    setFollowInfo: (state: any, action: Tction<{ followed: string }>) => {
      return {
        ...state,
        voteInfoModel: {
          ...state.voteeInfoModel,
          voteInfo: {
            ...state.voteInfoModel.voteInfo,
            authorInfo: {
              ...state.voteInfoModel.voteInfo.authorInfo,
              followed: action.payload.followed
            }
          }
        }
      };
    },
    // 设置投票详情数据
    setVoteInfo: (state: any, action: Tction<{ voteInfo: VoteQuestionPO }>) => {
      return {
        ...state,
        voteInfoModel: {
          ...state.voteInfoModel,
          voteInfo: action.payload.voteInfo
        }
      };
    },

    setHotComment: (state: any, action: Tction<{ hotComment: CommentInfo[] }>) => {
      return {
        ...state,
        voteInfoModel: {
          ...state.voteInfoModel,
          hotComment: action.payload.hotComment
        }
      };
    }
  },
  effects: {
    // 发布
    *publish(
      { tCall },
      action: Tction<{
        params: ParamsBodyvotePublishUsingPost;
        sendNotice: boolean;
        callBack: (res: CommonResultVoteQuestionPO) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack, sendNotice } = action.payload;
      const res = yield tCall(
        APIS.VoteApi.votePublishUsingPost,
        {
          sendNotice
        },
        params
      );

      callBack(res);
    },
    /**
     * 获取投票详情数据
     * @param param0
     * @param action
     */
    *getVoteInfoById(
      { tPut, tCall },
      action: Tction<{
        params: ParamsvoteGetUsingGet;
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.VoteApi.voteGetUsingGet> = yield tCall(
        APIS.VoteApi.voteGetUsingGet,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.setVoteInfo, {
          voteInfo: (res && res.result) || {}
        });
        callback && callback();
      } else {
        history.replace(`/common/error-handle-page`);
        return;
      }
    },
    /**
     * 关注
     * @param param0
     * @param action
     */
    *follow(
      { tPut, tCall },
      action: Tction<{
        params: ParamsvoteFollowVoteQuestionIdUsingPost;
        callback: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.VoteApi.voteFollowVoteQuestionIdUsingPost> = yield tCall(
        APIS.VoteApi.voteFollowVoteQuestionIdUsingPost,
        action.payload.params
      );
      if (res.code === 0) {
        yield tPut(model.actions.setFollowInfo, {
          followed: String(action.payload.params.type)
        });
      }
      action.payload.callback(res);
    },
    /**
     * 清空信息
     * @param param0
     * @param action
     */
    *cleanVoteInfo({ tPut }): Iterator<{}, any, any> {
      yield tPut(model.actions.setVoteInfo, {
        voteInfo: {}
      });
    },
    /**
     * 投票
     * @param param0
     * @param action
     */
    *doVote(
      { tPut, tCall },
      action: Tction<{
        params: ParamsvoteVoteQuestionIdUsingPost;
        callback: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.VoteApi.voteVoteQuestionIdUsingPost> = yield tCall(
        APIS.VoteApi.voteVoteQuestionIdUsingPost,
        action.payload.params
      );
      action.payload.callback(res);
    },
    /**
     * 发布观点
     * @param param0
     * @param action
     */
    *daCommentViewport(
      { tCall },
      action: Tction<{
        params: ParamsBodyvoteCommentUsingPost;
        callback: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      console.log('daCommentViewport--');
      const res: Utils.GetROA<typeof APIS.VoteApi.voteCommentUsingPost> = yield tCall(
        APIS.VoteApi.voteCommentUsingPost,
        action.payload.params
      );
      action.payload.callback(res);
    },
    /**
     * 获取热门评论
     * @param param0
     * @param action
     */
    *daGetHotComment(
      { tPut, tCall },
      action: Tction<{
        params: ParamsvoteCommentVoteQuestionIdHotUsingGet;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.VoteApi.voteCommentVoteQuestionIdHotUsingGet> = yield tCall(
        APIS.VoteApi.voteCommentVoteQuestionIdHotUsingGet,
        action.payload.params
      );
      if (res.code === 0) {
        yield tPut(model.actions.setHotComment, {
          hotComment: res.result || []
        });
      }
    },
    /**
     * 点赞评论
     * @param param0
     * @param action
     */
    *doThubmsHotComment(
      { tCall, tPut, select },
      action: Tction<{
        params: ParamscommentsThumbUpIdUsingPost;
        callback: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const hotComment = yield select((state: IRootState) => state.vote.voteInfoModel.hotComment);
      yield tPut(model.actions.setHotComment, {
        hotComment:
          hotComment &&
          hotComment.map((item: CommentInfo) => {
            if (item.id === action.payload.params.id) {
              return {
                ...item,
                hasLiked: true,
                thumbs: ((item && item.thumbs) || 0) + 1
              };
            }
            return item;
          })
      });
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsThumbUpIdUsingPost> = yield tCall(
        APIS.CommentApi.commentsThumbUpIdUsingPost,
        action.payload.params
      );
      action.payload.callback(res);
    },
    /**
     * 取消赞评论
     * @param param0
     * @param action
     */
    *doDeleteThubmsHotComment(
      { tCall, tPut, select },
      action: Tction<{
        params: ParamscommentsThumbUpIdUsingDelete;
        callback: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const hotComment = yield select((state: IRootState) => state.vote.voteInfoModel.hotComment);
      yield tPut(model.actions.setHotComment, {
        hotComment:
          hotComment &&
          hotComment.map((item: CommentInfo) => {
            if (item.id === action.payload.params.id) {
              return {
                ...item,
                hasLiked: false,
                thumbs: ((item && item.thumbs) || 0) - 1
              };
            }
            return item;
          })
      });
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsThumbUpIdUsingDelete> = yield tCall(
        APIS.CommentApi.commentsThumbUpIdUsingDelete,
        action.payload.params
      );
      action.payload.callback(res);
    }
  }
});

export default model;
